import { useEffect, useState } from 'react';

export interface ITab {
  id: string;
  title: string;
  content: React.ReactNode;
  isActive?: boolean;
  disabled?: boolean; // Новое поле для disabled состояния
}

export interface ITabsProps {
  tabs: ITab[];
  defaultActiveId?: string;
  activeId?: string;
  onChange?: (id: string) => void;
  navigationClassName?: string;
}

export const Tabs = ({ tabs, defaultActiveId, activeId, onChange, navigationClassName }: ITabsProps) => {
  // Фильтруем неотключенные табы для выбора активного
  const enabledTabs = tabs.filter((tab) => !tab.disabled);
  const initialActiveTab =
    (defaultActiveId && enabledTabs.find((tab) => tab.id === defaultActiveId)) ||
    enabledTabs.find((tab) => tab.isActive) ||
    enabledTabs[0];
  const [activeTab, setActiveTab] = useState(initialActiveTab?.id);
  const currentActiveTab = activeId ?? activeTab;

  useEffect(() => {
    if (activeId !== undefined) return;
    if (!defaultActiveId) return;
    setActiveTab(defaultActiveId);
  }, [activeId, defaultActiveId]);

  const handleTabChange = (tabId: string) => {
    if (activeId === undefined) {
      setActiveTab(tabId);
    }
    onChange?.(tabId);
  };

  return (
    <div className="w-full h-full font-comfortaa">
      {/* Навигация по табам */}
      <div className={`flex min-w-0 gap-2 overflow-x-auto overscroll-x-contain border-b border-gray-200 pb-1 ${navigationClassName ?? ''}`}>
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => !tab.disabled && handleTabChange(tab.id)}
            disabled={tab.disabled}
            className={`shrink-0 whitespace-nowrap rounded-t-[10px] px-3 py-2 text-sm font-medium border-b-2 focus-visible:ring-2 focus-visible:ring-redBase focus-visible:ring-inset lg:px-6 ${
              currentActiveTab === tab.id
                ? 'border-red-500 text-[#C00000]'
                : tab.disabled
                  ? 'text-gray-400 cursor-not-allowed border-transparent'
                  : 'border-transparent text-gray-500 hover:border-b-[#DEC05E]'
            }`}
          >
            {tab.title}
            {tab.disabled && <span className="ml-2 text-xs text-gray-400" />}
          </button>
        ))}
      </div>

      {/* Контент табов */}
      <div className="py-6">
        {tabs.map((tab) => (
          <div key={tab.id}>
            {!tab.disabled && currentActiveTab === tab.id && <div className="animate-fade-in">{tab.content}</div>}
          </div>
        ))}
      </div>
    </div>
  );
};
